# Corso di Programmazione a Blocchi

## Lezione 5 - Algoritmi Greedy

Bentornato nel corso di programmazione a blocchi per la preparazione ai Giochi di Fibonacci!

Questa è la quinta lezione, nella quale non introdurremo blocchi nuovi. Invece, vedremo alcuni esempi
di _soluzioni greedy_ a problemi in cui bisogna fare una serie di scelte. La soluzione greedy (che in
italiano si può tradurre come _"soluzione golosa"_) sceglierà sempre quello che le sembra meglio in quel
momento, senza pensare troppo al futuro!

Se non l'avessi ancora fatto, ti invitiamo a completare le lezioni precedenti prima di iniziare questa (anche se pensi di conoscere già quegli argomenti!).
**Attenzione: questa lezione è un po' più lunga delle prime quattro!**

## Punteggio e struttura delle lezioni

Le lezioni di questo corso contengono alcuni problemi di programmazione a blocchi, da risolvere in al massimo _4 giorni_. Appena avrai finito di lavorarci, potrai cliccare su "Termina" per vedere subito un riepilogo del punteggio che hai ottenuto, e le soluzioni spiegate di tutti i problemi! Se anche non lo farai, la lezione verrà terminata automaticamente dopo 4 giorni. Potrai comunque ricominciare la lezione quante volte vuoi, cliccando sul tasto "Ricomincia" (freccia curva che torna indietro).

I problemi richiedono di scrivere un **singolo** programma a blocchi, che viene valutato **contemporaneamente** su più livelli.
Quindi attenzione che non puoi scrivere programmi diversi per i diversi livelli, ma uno solo!
Per ciascun livello correttamente risolto di ciascun problema, otterrai _5 punti_.

Quando termini la lezione, ti consigliamo di **leggere tutte le soluzioni spiegate**, anche dei problemi che avevi
già risolto correttamente: potresti scoprire modi diversi di risolvere quegli stessi problemi, e dei suggerimenti
che ti potrebbero tornare utili per altri problemi simili che troverai in futuro!